import React from "react";
import AdminSetup from "./AdminSetup";

const KeyConfiguration = () => {
  return <AdminSetup />;
};

export default KeyConfiguration;
